import axios from "axios";
import { normaliseerPad, report } from "./guardian";

/**
 * Meldt mislukte API-aanroepen (Exact, SVZ, mail, cms) aan Guardian.
 *
 * Eén interceptor op de standaard axios-instantie vangt alles af, want overal
 * in het CMS wordt `axios` rechtstreeks geïmporteerd.
 *
 * **Alleen 5xx en netwerkfouten.** Een 4xx is vrijwel altijd een verwacht
 * antwoord dat het scherm zelf afhandelt (niet gevonden, validatie, een
 * verlopen sessie); die melden zou het kanaal vullen met ruis. Gaat de API
 * onderuit of is hij onbereikbaar, dan hoort iemand dat te weten.
 */

export const installApiErrorReporting = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const status = error?.response?.status;
        const url = error?.config?.url;

        // Guardian zelf niet melden: een onbereikbare meldpost die zichzelf meldt.
        if (!url || url.includes("guardian.digitalkiss.nl")) return Promise.reject(error);

        if (status && status < 500) return Promise.reject(error);

        const route = normaliseerPad(url);
        report({
          severity: "error",
          type: "api_exception",
          title: status ? `API-aanroep mislukt (${status}): ${route}` : `API onbereikbaar: ${route}`,
          context: { status: status || "netwerkfout", methode: error?.config?.method, melding: error?.message },
        });
      } catch (e) {
        // Melden mag de oorspronkelijke fout nooit vervangen.
      }
      return Promise.reject(error);
    },
  );
};

export default installApiErrorReporting;
